var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer color-black"},[_c('span',[_vm._v("Copyright 2015-"+_vm._s(new Date().getFullYear()))]),_vm._m(0),_c('a',{staticClass:"color-black"},[_vm._v("浙ICP备16000551号")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"margin"},[_vm._v(" 版权所有： "),_c('a',{attrs:{"href":"https://xiaoxxx.com","target":"_blank"}},[_vm._v("杭州小仙科技有限公司")])])
}]

export { render, staticRenderFns }